(function () {

  'use strict';


  function initVSLookingFor(section) {

    if (!section) {
      return;
    }


    if (
      section.dataset.vsInitialized === 'true'
    ) {
      return;
    }


    section.dataset.vsInitialized = 'true';


    const cards =
      section.querySelectorAll(
        '.vs-looking-for__card'
      );


    /* ================================================
       CARD INTERACTION
    ================================================ */

    cards.forEach(function (card) {

      const image =
        card.querySelector(
          '.vs-looking-for__image'
        );


      if (!image) {
        return;
      }


      card.addEventListener(
        'mouseenter',
        function () {

          image.style.transform =
            'scale(1.05)';

        }
      );


      card.addEventListener(
        'mouseleave',
        function () {

          image.style.transform =
            'scale(1)';

        }
      );


      /* ============================================
         TOUCH
      ============================================ */

      card.addEventListener(
        'touchstart',
        function () {

          image.style.transform =
            'scale(1.035)';

        },
        {
          passive: true
        }
      );


      card.addEventListener(
        'touchend',
        function () {

          setTimeout(function () {

            image.style.transform =
              'scale(1)';

          }, 180);

        },
        {
          passive: true
        }
      );

    });


    /* ================================================
       MOBILE HORIZONTAL SCROLL
    ================================================ */

    const grid =
      section.querySelector(
        '.vs-looking-for__grid'
      );


    if (!grid) {
      return;
    }


    let isDown = false;

    let startX = 0;

    let startScroll = 0;


    grid.addEventListener(
      'mousedown',
      function (event) {

        if (
          window.innerWidth > 749
        ) {
          return;
        }


        isDown = true;

        startX =
          event.pageX;

        startScroll =
          grid.scrollLeft;

      }
    );


    grid.addEventListener(
      'mousemove',
      function (event) {

        if (!isDown) {
          return;
        }


        event.preventDefault();


        const distance =
          event.pageX - startX;


        grid.scrollLeft =
          startScroll - distance;

      }
    );


    function stopDrag() {

      isDown = false;

    }


    grid.addEventListener(
      'mouseup',
      stopDrag
    );


    grid.addEventListener(
      'mouseleave',
      stopDrag
    );


    /* ================================================
       PREVENT IMAGE DRAG
    ================================================ */

    section
      .querySelectorAll('img')
      .forEach(function (img) {

        img.addEventListener(
          'dragstart',
          function (event) {

            event.preventDefault();

          }
        );

      });

  }


  /* ================================================
     INITIALIZE
  ================================================ */

  function initAll() {

    document
      .querySelectorAll(
        '[data-vs-looking-for]'
      )
      .forEach(function (section) {

        initVSLookingFor(section);

      });

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );

  } else {

    initAll();

  }


  /* ================================================
     SHOPIFY THEME EDITOR
  ================================================ */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const id =
        event.detail &&
        event.detail.sectionId;


      if (!id) {
        return;
      }


      const section =
        document.getElementById(
          'vs-looking-for-' + id
        );


      if (section) {

        section.dataset.vsInitialized =
          'false';

        initVSLookingFor(section);

      }

    }
  );


  document.addEventListener(
    'shopify:block:select',
    function (event) {

      const block =
        event.target;


      if (
        block &&
        block.classList &&
        block.classList.contains(
          'vs-looking-for__card'
        )
      ) {

        block.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });

      }

    }
  );


})();